import React, { useEffect, useState } from 'react';
import { withContent } from '../../hoc/withContext';

const SubscriptionButton = ({ idToAttach }) => {
  const [fetchingButton, setFetchingButton] = useState(true);

  useEffect(() => {
    if (document.getElementById('hidden-subscription-button') && fetchingButton) {
      setFetchingButton(buttonLoaded => false);
      let clone = document.querySelector('#hidden-subscription-button').cloneNode( true );
      clone.setAttribute( 'id', 'clonedButtonShell');
      clone.style.display = "block"
      document.querySelector("#" + idToAttach ).appendChild( clone );
    }
  })
  return (
    <div className={"ubisoft-plus_cta_wrapper"} id={idToAttach}/>
  );
};

export default withContent(SubscriptionButton);